export { SVGIcon } from './SVGIcons/SVGIcon'
export { default as CardIcon } from './PaymentIcons/CardIcon/CardIcon'
export { default as AfterPayIcon } from './PaymentIcons/AfterPayIcon'
export { default as AffirmIcon } from './PaymentIcons/AffirmIcon'
export { default as PayPalIcon } from './PaymentIcons/PayPalIcon'
export { default as KlarnaIcon } from './PaymentIcons/KlarnaIcon'
